import React, { useContext, useState } from "react";
import checkBoxChk from "../../../assets/check-box.png";
import checkBoxEpt from "../../../assets/empty-checkbox.png";
import "./modal.scss";

import { Layout, Row, Col, Table, Button, Modal, Empty } from "antd";
import { Grid } from "semantic-ui-react";
import { EditOutlined} from "@ant-design/icons";
import EvaluacionCriteriosModel from "./EvaluacionCriteriosModel";
import EvaluacionCriteriosModelEdit from "./EvaluacionCriteriosModelEdit";
import "../../../App.scss";
import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { RootState } from "../../../redux/reducers/index";
import { useSelector } from "react-redux";
import { Jurado } from "../../../models/JuradosModel/jurados.model";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { openNotification } from "../../../utils/Notifactions";
import apiJurados from "../../../api/Jurados/api-jurados";
import { TemplateContext } from "../../../utils/template_context";
import { ObjNotificaciones } from "../../../config/notificaciones";

export const EvaluacionCriterios = () => {
  const state = useSelector((state: RootState) => state.jurado);
  const { Content } = Layout;

  const [isModalVisible, setIsModalVisible] = useState<any>(false);

  const [datosActuales, setDatosActuales] = React.useState<Array<Jurado>>([]);

  const [editValue, setEditValue] = useState<any>([]);
  const [editValueList, setEditValueList] = useState<any>([]);
  const [editAssignedCat, setEditAssignedCat] = useState<any>({});
  const [editAssignedModl, setEditAssignedModl] = useState<any>(false);
  const [allCheckbox, setAllCheckbox] = useState<any>(false);
  const navigate = useNavigate();
  const context = useContext(TemplateContext);

  useEffect(() => {
    cargarJuradosCriterios();
  }, []);

  const cargarJuradosCriterios = async () => {
    const token = localStorage.getItem('token');

    let datacriterio = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}juries/obtenerJuradosConCriterios`, {
      headers: {
        'Authorization': token
      }
    });

    let criterios: Array<Jurado> = [];
    let { data } = await apiJurados.consultarProjectosJurados();
    let sincriterios = data.juries
    if (state.jurados.length > 0) {
      state.jurados.forEach((data: Jurado) => {
        let filtercriterio = datacriterio.data.data.filter((x: Jurado) => x.id_jurado === data.id_jurado);
        let filtersincriterio = sincriterios.filter((x: Jurado) => x.id_jurado === data.id_jurado);
        if (filtercriterio.length > 0) {
          criterios = [...criterios, filtercriterio[0]];
        }
        if (filtersincriterio.length > 0) {
          sincriterios = [...sincriterios, filtersincriterio[0]];
        }
      });
      setEditValueList(criterios);

      return setDatosActuales(sincriterios);
    } else {
      ObjNotificaciones.MSG_ERROR('warning', 'Selección de jurados', 'Por favor, selecciona los jurados en el paso anterior de asignación de jurados a proyectos');
      return navigate('/administrador/asignarJurados');
    }

  };

  const columns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 50,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Nombre jurado</span>,
      width: 300,
      render: (datos: any) => {
        return (
            <span>{`${datos.primer_nombre} ${datos.segundo_nombre == null ? '' : datos.segundo_nombre} ${datos.primer_apellido} ${datos.segundo_apellido == null ? '' : datos.segundo_apellido}`}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Documento</span>,
      width: 100,
      render: (datos: any) => {
        return (
            <span>{`${datos.numero_documento}`}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: () => (
        <p className="text-center">
          <span className="as_tbl_hd" style={{ marginRight: '15px' }}>Seleccionar todos </span>

          <button type="button" onClick={() => handelCheckAllData()} className="chkImg" style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>
            <img
              src={allCheckbox ? checkBoxChk : checkBoxEpt}
              width={allCheckbox ? 12 : 18}
              alt=""
            />
          </button>{" "}
        </p>
      ),
      width: 70,
      fixed: context.device === "lg" ? "right" : false,
      render: (text: any, record: any, index: any) => (
        <p className="text-center">
          {editValue.findIndex((item: any) => item.id_jurado == record.id_jurado) >= 0 ? (
            <button type="button" onClick={() => setCheckBoxValue(record)} style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>
              <img src={checkBoxChk} width={12} alt="seleccionado" />
            </button>
          ) : (
            <button type="button" onClick={() => setCheckBoxValue(record)} style={{background:'none',border:'none',padding:0,cursor:'pointer'}}>
              <img src={checkBoxEpt} width={18} alt="sin seleccionar" />
            </button>
          )}
        </p>
      ),
    },
  ];

  function setCheckBoxValue(item: any) {
    let valueda = editValue;
    const arrIndex = editValue.findIndex((items: any) => items.id_jurado == item.id_jurado);

    if (allCheckbox) {
      setAllCheckbox(false);
    }
    if (arrIndex >= 0) {
      valueda.splice(arrIndex, 1);
      setEditValue([...valueda]);
    } else {
      setEditValue([...valueda, item]);
    }
  }

  function handelCheckAllData() {

    let valueda = editValue;
    if (allCheckbox) {
      setAllCheckbox(false);
      setEditValue([]);
    } else {
      setAllCheckbox(true);
      // setEditValue(datosActuales)
      setEditValue([...valueda, ...datosActuales]);
    }
  }

  const columnsEdit: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 50,
      // dataIndex: "idconvocatorias",
      key: "id_jurado",
      fixed: context.device === "md" ? "left" : false,
      render: (text: any, record: any) => <div>{editValueList.indexOf(record) + 1}</div>,
    },
    {
      title: <span className="as_tbl_hd">Nombre jurado</span>,
      width: 300,
      render: (datos: any) => {
        return (
            <span>{`${datos.primer_nombre} ${datos.segundo_nombre == null ? '' : datos.segundo_nombre} ${datos.primer_apellido} ${datos.segundo_apellido == null ? '' : datos.segundo_apellido}`}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Documento</span>,
      width: 100,
      render: (datos: any) => {
        return (
            <span>{`${datos.numero_documento}`}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: () => (
        <p className="text-center">
          <span className="as_tbl_hd">Seleccionar </span>
          <small className="pr-1 ast_tbl_txt_sml" style={{ fontSize: "10px" }}>
            {" "}
            Editar
          </small>{" "}
          <small className="pr-1 ast_tbl_txt_sml">Eliminar</small>
        </p>
      ),
      width: 70,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, datos2: any, index: any) => (
          <p className="text-center">
            <button type="button" onClick={() => editCriterio(datos, datos2)}>
              <EditOutlined />
            </button>
            {"  "}
          </p>
      ),
    },
  ];

  const editCriterio = (datos: any, datos2: any) => {

    editVisibleFormList(datos2)
  }

  function editVisibleFormList(item: any) {
    setEditAssignedCat(item);
    setEditAssignedModl(true);
    setIsModalVisible(true);
  }

  function handelFormSubmit() {
    // console.log(allCheckbox, 'allCheckbox')
    if (allCheckbox) {
      setDatosActuales([]);
    }
    setEditAssignedModl(false);
    setIsModalVisible(true);
  }

  const routes = [{ nombre: "Jurados" }, { nombre: "Evaluar criterios" }];

  return (
    <div className="background-color-F7FBFF h-100">
      <Modal className="transparent" visible={isModalVisible} closable={false} footer={false} width={1000}>
        {editAssignedModl ? (
          <EvaluacionCriteriosModelEdit
            setIsModalVisible={setIsModalVisible}
            editAssignedCat={editAssignedCat}
            setEditAssignedCat={setEditAssignedCat}
            editValue={editValue}
            setEditValue={setEditValue}
            setEditValueList={setEditValueList}
          />
        ) : (
          <EvaluacionCriteriosModel
            setIsModalVisible={setIsModalVisible}
            editValue={editValue}
            editValueList={editValueList}
            setEditValue={setEditValue}
            setEditValueList={setEditValueList}
            datosActuales={datosActuales}
            setDatosActuales={setDatosActuales}
          />
        )}
      </Modal>
      <Grid className="no-margin" style={{ paddingTop: "0 !important", paddingBottom: "0 !important" }}>
        <Grid.Column className="background-color-101c31 no-margin no-padding-top no-padding-bottom">
          <BreadCrumbAdmin routes={routes} />
        </Grid.Column>
      </Grid>
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <Grid columns={2} className="mt-3 mb-3">
          <Row className="width-100" style={{ padding: "1%", display: "flex", justifyContent: "center" }}>
            <Row className="row-shadow width-100" style={{ width: "95%" }}>
              <Col span={24}>
                <Content className="asgn_eval__card">
                  <Content className="asgevl_card_header">
                    <h4 className="title asgevl_title font-family-Montserrat-SemiBold">
                      Asignar criterios de evaluación a jurados
                    </h4>
                    <hr style={{ marginBottom: 20 }} />
                  </Content>
                  <Content className="asgevl_contain" style={{ paddingLeft: "10px", marginBottom: "15px" }}>
                    <p className="asgevl_text" style={{ fontFamily: "Work-Sans-Regular", fontSize: "15px" }}>
                      Seleccione los{" "}
                      <b style={{ fontFamily: "Work-Sans-Regular", fontSize: "15px" }}>
                        {" "}
                        jurados que evaluarán bajo los mismos criterios.
                      </b>{" "}
                      Para guardar y continuar debe asignarle criterios de evaluación a todos los jurados.
                    </p>
                  </Content>
                  <Content className="asgevl_table_box mt-1">
                    <Content className="">
                      <Row>
                        <Col span={16} style={{ marginBottom: "15px" }}>
                          <span className="" style={{ fontFamily: "Work-Sans-Regular", fontSize: "17px" }}>
                            Jurados
                          </span>
                        </Col>
                        <Col span={8}>
                          <Content className="text-right">
                            <span
                              className="asgevl_tbl_right_text table--total text-right "
                              style={{ fontFamily: "Work-Sans-Regular", fontSize: "15px", paddingRight: "1rem" }}
                            >
                              Total :{" "}
                              <span
                                className="text-orance"
                                style={{
                                  marginLeft: "5px",
                                  fontFamily: "Work-Sans-Regular",
                                  fontSize: "15px",
                                  color: "orange",
                                }}
                              >
                                {datosActuales.length}
                              </span>
                            </span>

                            <span
                              className="asgevl_tbl_right_text table--total text-right"
                              style={{ fontFamily: "Work-Sans-Regular", fontSize: "15px" }}
                            >
                              Jurados seleccionados{" "}
                              <span
                                className="text-orance"
                                style={{
                                  marginLeft: "5px",
                                  fontFamily: "Work-Sans-Regular",
                                  fontSize: "15px",
                                  color: "orange",
                                }}
                              >
                                {editValue.length}
                              </span>
                            </span>
                          </Content>
                        </Col>
                      </Row>
                    </Content>

                    <Content className="mb-1">
                      {
                        //@ts-ignore
                        // <Table columns={columns}
                        //     rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                        //     dataSource={datosActuales}
                        //     scroll={{ x: 800, y: 300 }}
                        //     size="small"
                        //     className="table-ant-design-modify"
                        //     bordered={false}
                        //     pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadPáginas }}
                        // />
                      }
                      {
                        //@ts-ignore
                        <Table
                          columns={columns}
                          style={{ borderTop: "1px solid #C4C4C4" }}
                          locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                          pagination={false}
                          /* pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadPáginas }} */
                          dataSource={datosActuales}
                          scroll={{ x: 800, y: 300 }}
                          size="small"
                          rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                          className="table-ant-design-modify"
                          bordered={false}
                        />
                      }
                    </Content>
                    <Content
                      className="mb-2"
                      style={{ marginBottom: "20px", display: "flex", justifyContent: "flex-end" }}
                    >
                      <Row className="">
                        <Col span={24} className="form--btm-btn-box">
                          {editValue.length > 0 ? (
                            <Button className="button-blanco-radius" onClick={() => handelFormSubmit()}>
                              Asignar Criterios
                            </Button>
                          ) : (
                            <Button className="button-blanco-radius" type="primary">
                              Asignar Criterios
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Content>
                  </Content>

                  <Content className="asgevl_table_box mt-1">
                    <Content className="evalpro_table_head asgevl_tbl_head">
                      <Row>
                        <Col span={16}>
                          <span className="tbl__head" style={{ fontFamily: "Work-Sans-Regular", fontSize: "20px" }}>
                            Jurados con criterios asignados
                          </span>
                        </Col>
                        <Col span={8}></Col>
                      </Row>
                    </Content>

                    <Content className="mb-1">
                      {
                        //@ts-ignore
                        <Table
                          columns={columnsEdit}
                          dataSource={editValueList}
                          scroll={{ x: 800, y: 300 }}
                          size="small"
                          //rowClassName="sizeTable table-row"
                          className="table-ant-design-modify"
                          bordered={false}
                          pagination={false}
                          rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                        />
                      }
                    </Content>

                    <Content className="mb-2" style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Row className="">
                        <Col span={24} className="form--btm-btn-box">
                          {editValueList && editValueList.length > 0 ? (
                            <Button
                              className="button-azul-radius"
                              type="primary"
                              onClick={() => navigate("/Administrador/asignarJurados")}
                            >
                              Guardar y Continuar
                            </Button>
                          ) : (
                            <Button
                              className="button-gray-ghost"
                              type="primary"
                              onClick={() => {
                                if (editValueList.length === 0) {
                                  return openNotification({
                                    titulo: "Error",
                                    descripcion: "Debe agregar criterios para poder guardar",
                                    placement: "bottomRight",
                                  });
                                }

                                navigate("/Administrador/asignarJurados")
                              }}
                            >
                              Guardar y Continuar
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Content>
                  </Content>
                </Content>
              </Col>
            </Row>
          </Row>
        </Grid>
      </div>
      <Row className="container-sticky-footer" style={{ height: 72 }}>
        <Row className="no-margin">
          <Col span={24}>
            {/* <Button className="button-blanco-radius">Atrás</Button> */}
          </Col>
        </Row>
      </Row>
    </div>
  );
};
